import React from 'react';
import Button from '../button';

const UpcomingMatchesCta = ({ togglePopup }) => {
  return (
    <>
      <div className='si-upcomingMatches__cta'>
        <Button
          transKey={'cta_upcoming_matches'}
          variant={'secondaryLink'}
          icon={'lms-chevron-right'}
          onClick={togglePopup}
        >
          Upcoming Matches
        </Button>
      </div>
    </>
  );
};

export default UpcomingMatchesCta;
